<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

      <el-radio-group v-model="filteringProductType" size="mini" @change="delaySearch">
        <el-radio-button :label="null">全部</el-radio-button>
        <el-radio-button :label="0">一般商品</el-radio-button>
        <el-radio-button :label="1">加價購商品</el-radio-button>
      </el-radio-group>

      <el-radio-group v-model="filteringStatus" size="mini" @change="delaySearch">
        <el-radio-button :label="null">全部</el-radio-button>
        <el-radio-button :label="true">發佈</el-radio-button>
        <el-radio-button :label="false">下架</el-radio-button>
      </el-radio-group>

    </template>
    <template slot="right">
      <el-button @click="$router.push({ name: 'product-list-sortable', query: routeQuery})" style="margin-right: 0;">拖曳排序</el-button>
      <el-button @click="exportExcel" style="margin-right: 0;">Excel匯出</el-button>
      <el-button @click="onCreate" style="margin-right: 20px;">新增</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="圖片" width="50px">
            <template slot-scope="scope">
              <img
                :src="getProductDataCoverImageURL(scope.row.Tw)"
                class="w-100"/>
            </template>
          </el-table-column>
        <el-table-column label="商品名稱">
          <template slot-scope="scope">
            {{scope.row.Tw.Name}}
          </template>
        </el-table-column>
        <el-table-column label="原價" width="100px">
          <template slot-scope="scope">
            <div class="text-___" style="padding-right: 0">
              NT$ {{scope.row.Tw.OriginalPrice|amountFormat}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="特價" width="100px">
          <template slot-scope="scope">
            <div class="text-___" style="padding-right: 0" v-if="scope.row.Tw.Discount && isActiveIng(scope.row.Tw.Discount)">
              NT$ {{scope.row.Tw.Discount.Price|amountFormat}}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="config.isProductInStockEnabled" label="庫存" width="60px">
          <template slot-scope="scope">
            {{scope.row.InStock}}
          </template>
        </el-table-column>
        <el-table-column label="排序" width="60px">
          <template slot-scope="scope">
            {{scope.row.SortOrder}}
          </template>
        </el-table-column>
        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="isPublished(scope.row.Tw)" class="deployed">發佈</p>
            <p v-else-if="isClosed(scope.row.Tw)" class="closed">下架<!--已下架--></p>
            <p v-else-if="notReleaseYet(scope.row.Tw)" class="waiting">下架<!--待發佈--></p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <!-- <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" :width="config.isProductInStockEnabled ? '210px' : '120px'">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="onUpdate(scope.row.ID)">編輯</el-button>

            <el-button
              v-if="config.isProductInStockEnabled"
              size="mini"
              round
              :ori-obj="editingInStockObj"
              @click="showInStockModal(scope.row)">庫存管理</el-button>

            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="10"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

      <product-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onObjAddedited" :ori-obj="editingObj"/>
      <product-instock-modal :isShow="isShowInStockModal" @close="isShowInStockModal = false" @submitted="()=>{}" :ori-obj="editingInStockObj"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import ProductEditorModal from '@/data/product/view/editor-modal.vue'
import ProductInstockModal from '@/data/product/view/modal-instock.vue'
import Config from '@/assets/js/config.js'
// svgs
import '@/assets/svgs/index.js'
// excel
import ExcelGenerator from '../excel'
import XLSXSaver from '@/utils/excel/xlsx-saver.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader,
    ProductEditorModal,
    ProductInstockModal
  },
  data () {
    return {
      config: Config,
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null,
      filteringProductType: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null,
      // instock
      isShowInStockModal: false,
      editingInStockObj: null
    }
  },
  computed: {
    dataList () {
      return this.$store.state.product.list.filter(o => o.IsActive && !o.TeamBuyingID).sort((o1, o2) => o1.SortOrder - o2.SortOrder)
    },
    routeQuery () {
      let query = {
        frompage: this.currentPage
      }
      if (this.keyword) query.keyword = this.keyword
      if (this.filteringDateRange) query.filteringDateRange = JSON.stringify(this.filteringDateRange)
      if (this.filteringProductType !== null)query.filteringProductType = this.filteringProductType
      if (this.filteringStatus !== null)query.filteringStatus = this.filteringStatus
      return query
    }
  },
  methods: {
    onCreate () {
      const showCreator = () => {
        this.$router.push({ name: 'createProduct', query: this.routeQuery })
      }
      // 商品可以選擇產地情報，要先preload
      if (
        !this.$store.state.originInfo.isFetched &&
        !this.$store.state.originInfo.isFetching
      ) {
        this.$services.fetchOriginInfoDatas(this).then(showCreator).catch(this.$handleServiceError)
      } else {
        showCreator()
      }
    },
    onUpdate (id) {
      const showEditor = () => {
        this.$router.push({ name: 'updateProduct', params: { id: id }, query: this.routeQuery })
      }
      // 商品可以選擇產地情報，要先preload
      if (
        !this.$store.state.originInfo.isFetched &&
        !this.$store.state.originInfo.isFetching
      ) {
        this.$services.fetchOriginInfoDatas(this).then(showEditor).catch(this.$handleServiceError)
      } else {
        showEditor()
      }
    },
    exportExcel () {
      try {
        let datas = this.searchedObjs
        let result = ExcelGenerator.generate(this, datas)

        var fileName = window.prompt(
          '請輸入匯出Excel檔之名稱',
          '旬果屋購物官網-商品匯出'
        )
        if (fileName === null) return // 取消
        if (!fileName) return window.alert('請輸入檔案名稱')
        XLSXSaver.saveAs(result, fileName)
      } catch (e) {
        alert('發生錯誤:' + e)
        window.console.error(`匯出異常`, e)
      }
    },
    showInStockModal (obj) {
      this.editingInStockObj = obj
      this.isShowInStockModal = true
    },
    isActiveIng (obj) {
      var now = moment(new Date())
      var started = true
      if (obj.BeginAt != null) started = now.isAfter(obj.BeginAt)
      if (!started) return false

      var finished = false
      if (obj.EndAt != null) finished = now.isAfter(moment(obj.EndAt).add(1, 'days'))
      if (finished) return false

      return true
    },
    getProductDataCoverImageURL (productData) {
      if (!productData.imagesJsonArr) productData.imagesJsonArr = JSON.parse(productData.Images)
      return (productData.imagesJsonArr[0] || {})['@1']
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 10, page * 10)
    },
    onDateRangeChanged () {
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 10)
    },
    filterObjs () {
      if (!this.keyword && this.filteringStatus === null && !this.filteringDateRange && this.filteringProductType === null) {
        this.searchedObjs = this.dataList
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.Tw && o.Tw.Name && o.Tw.Name.includes(this.keyword)) return true
        if (o.Cn && o.Cn.Name && o.Cn.Name.includes(this.keyword)) return true
        if (o.En && o.En.Name && o.En.Name.includes(this.keyword)) return true
        if (o.Jp && o.Jp.Name && o.Jp.Name.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (this.filteringStatus === null) return true
        return this.filteringStatus === this.isPublished(o.Tw)
      }

      const isObjFitType = o => {
        if (this.filteringProductType === null) return true
        return o.ProductType == this.filteringProductType
      }

      let startDate = this.filteringDateRange && moment(this.filteringDateRange[0])
      let endDate = this.filteringDateRange && moment(this.filteringDateRange[1])
      const isObjFitDateRange = o => {
        if (!this.filteringDateRange) return true
        let date = moment(o.CreatedAt)
        return (date.isBefore(endDate) && date.isAfter(startDate)) || date.isSame(startDate, 'date') || date.isSame(endDate, 'date')
      }

      this.searchedObjs = this.dataList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u) && isObjFitDateRange(u) && isObjFitType(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.Tw.Name}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.product.inActivate(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.product.list.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$set(this.$store.state.product.list[idx], 'IsActive', false)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 10,
            this.currentPage * 10
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    isPublished (obj) {
      let closedAt = obj.CloseAt ? moment(obj.CloseAt).add(1, 'days') : null
      return obj.IsActive && (obj.ReleaseAt == null || moment(new Date()).isAfter(obj.ReleaseAt)) && (obj.CloseAt == null || moment(new Date()).isBefore(closedAt))
    },
    isClosed (obj) {
      let closedAt = obj.CloseAt ? moment(obj.CloseAt).add(1, 'days') : null
      return obj.IsActive && (obj.ReleaseAt == null || moment(new Date()).isAfter(obj.ReleaseAt)) && !(obj.CloseAt == null || moment(new Date()).isBefore(closedAt))
    },
    notReleaseYet (obj) {
      let closedAt = obj.CloseAt ? moment(obj.CloseAt).add(1, 'days') : null
      return obj.IsActive && !(obj.ReleaseAt == null || moment(new Date()).isAfter(obj.ReleaseAt)) && (obj.CloseAt == null || moment(new Date()).isBefore(closedAt))
    }
  },
  created () {
    this.currentPage = parseInt(this.$route.query.page) || 1
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword
    if (this.$route.query.filteringDateRange) this.filteringDateRange = JSON.parse(this.$route.query.filteringDateRange)
    if (this.$route.query.filteringProductType !== undefined)this.filteringProductType = this.$route.query.filteringProductType
    if (this.$route.query.filteringStatus !== undefined)this.filteringStatus = this.$route.query.filteringStatus == 'true'

    const initTableData = () => {
      this.filterObjs()
      this.onChangePage(this.currentPage)
    }

    if (
      !this.$store.state.product.isFetched &&
      !this.$store.state.product.isFetching
    ) {
      this.$services.fetchProductDatas(this).then(initTableData).catch(this.$handleServiceError)
    } else {
      initTableData()
    }
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
.waiting {
  color: rgb(0, 149, 175);
  font-weight: 700;
}
.closed {
  color: #2a2a2a;
}
</style>
